import { Dropdown, Progress } from "antd";
import { FloatingForm, formatDate } from "../../../components/common/Converter";
import { useState } from "react";
import CardView from "../../../components/common/CardView";
import { Button, dialog } from "nq-component";
import InputFactory from "../../../components/InputFactory";
import RichText from "../../../components/common/RichText";
import { upsertUseCase } from "../../../usecases/object";
import { createNotification } from "../../../createNotification";

export default function ForProcessing({
  objects,
  currentUser,
  fetchData,
  processStatus,
}) {
  const [isOnView, setIsOnView] = useState(false);
  const [object, setObject] = useState({});

  const handleViewObj = (request) => {
    setIsOnView(true);
    setObject(request);
  };

  const confirmationDialog = (request, status) => {
    let reason = ""; // Local variable to store the reason input value
    let attachement = [];

    const handleReasonChange = (status, value) => {
      if (status === "Rejected") {
        reason = value; // Update the reason
      } else {
        // ✅ Ensure `request.attachement` is an array
        const existingAttachments = Array.isArray(request.attachement)
          ? request.attachement
          : [];

        // ✅ Ensure `value` is an array before spreading
        const newAttachments = Array.isArray(value) ? value : [value];

        // ✅ Push all valid attachments
        attachement = [...existingAttachments, ...newAttachments];
      }
    };

    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Submit {status} Request</h4>
            <hr />
            {(status === "Reject" || status === "Validate") && (
              <div className="pe-4 ps-4">
                <label>
                  {status === "Reject" ? "Reason" : "Attachment"}
                  {/* <span className="text-danger">*</span> */}
                </label>
                <InputFactory
                  type={status === "Reject" ? "Text" : "File"}
                  onChange={(val) => handleReasonChange(status, val)} // Update reason on change
                  className="form-control"
                  required
                />
              </div>
            )}
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click confirm to proceed.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => {
                if (status === "Approve") {
                  handleApprove(request);
                } else if (status === "Reject") {
                  handleReject(request, reason); // Pass the reason when rejecting
                } else {
                  handleNext(request, attachement);
                }
                dialog.close(); // Close the dialog after handling
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  };

  const handleApprove = async (request) => {
    request.workFlow.tasks[0].request = "approved";
    request.employee = { id: request.employee.id };
    if (request.stats === "Pending") {
      request.stats = "Approved";
    }
    try {
      const message = "Successfully Approved service request!";
      await serviceRequestLogs(request, "Approve", message);
      await upsertUseCase().execute("requests", request);

      //  CREATE NOTIFICATION
      const NOTIFICATION_MESSAGE =
        "You have been assigned as a validator on your Task Board!";
      const NOTIFICATION_RECEIVER = [
        request.workFlow.tasks[0].hierarchy.request.id,
      ];
      const NOTIFICATION_REDIRECT = "taskboard";

      createNotification(
        NOTIFICATION_MESSAGE,
        NOTIFICATION_RECEIVER,
        NOTIFICATION_REDIRECT,
      );
      fetchData();
    } catch (e) {
      console.error("Approve error: ", e.message || e);
    }
  };

  const handleReject = async (request, rejectReason) => {
    request.workFlow.tasks[0].request = "reject";
    request.reason = rejectReason;
    request.employee = { id: request.employee.id };
    // service logs
    try {
      const message = `Successfully Rejected service reuqest! Reason: ${rejectReason}`;
      await serviceRequestLogs(request, "Reject", message);
      await upsertUseCase().execute("requests", request);
      console.log("Reject Object:", request);
      dialog.close();

      //  CREATE NOTIFICATION
      const NOTIFICATION_MESSAGE =
        "You have been assigned as a validator on your Task Board!";
      const NOTIFICATION_RECEIVER = [
        request.workFlow.tasks[0].hierarchy.request.id,
      ];
      const NOTIFICATION_REDIRECT = "taskboard";

      createNotification(
        NOTIFICATION_MESSAGE,
        NOTIFICATION_RECEIVER,
        NOTIFICATION_REDIRECT,
      );

      fetchData();
    } catch (e) {
      console.error("Reject error: ", e.message || e);
    }
  };

  const handleNext = async (request, attachement) => {
    // Copy the tasks array
    let updatedTasks = [...request.workFlow.tasks];

    request.attachement = attachement;

    const message = `Service request submitted successfully`;
    await serviceRequestLogs(request, "Submitted", message);

    if (updatedTasks.length > 1) {
      // Move the first element (index 0) to the last position
      const temp = updatedTasks.shift(); // Remove the element at index 0
      updatedTasks.push(temp); // Add it to the last position

      // Update the index field for all tasks to reflect the new positions
      updatedTasks = updatedTasks.map((task, index) => {
        return {
          ...task,
          index: index,
        };
      });
    }

    request.employee = { id: request.employee.id };

    if (request?.workFlow?.tasks[0]?.request === "reject") {
      request.stats = "Rejected";
      await upsertUseCase().execute("requests", request);

      //  CREATE NOTIFICATION
      const NOTIFICATION_MESSAGE = "Your Service Request has been rejected!";
      const NOTIFICATION_RECEIVER = [request.employee.id];
      const NOTIFICATION_REDIRECT = "service";

      createNotification(
        NOTIFICATION_MESSAGE,
        NOTIFICATION_RECEIVER,
        NOTIFICATION_REDIRECT,
      );

      fetchData();
      return;
    }
    // Set the updated tasks back into the request object
    const updatedRequest = {
      ...request,
      workFlow: {
        ...request.workFlow,
        tasks: updatedTasks,
      },
    };

    console.log("TASK: ", updatedRequest);

    if (
      updatedRequest.stats === "Pending" ||
      updatedRequest.stats === "Approved"
    ) {
      updatedRequest.stats = "In-Progress";
      updatedRequest.taskIndex = updatedRequest.workFlow.tasks.length;
      updatedRequest.workFlow.tasks.map((item) => (item.request = ""));
      await upsertUseCase().execute("requests", updatedRequest);

      //  CREATE NOTIFICATION
      const notifications = [
        {
          message: "You have been assigned as an approver on your Task Board!",
          receiver: [updatedRequest.workFlow.tasks[0].hierarchy.approve.id],
        },
        {
          message: "You have been assigned as a rejector on your Task Board!",
          receiver: [updatedRequest.workFlow.tasks[0].hierarchy.reject.id],
        },
      ];

      notifications.forEach(({ message, receiver }) => {
        createNotification(message, receiver, "taskboard");
      });

      fetchData();
    }
    if (updatedRequest.taskIndex !== 1) {
      updatedRequest.taskIndex = updatedRequest.taskIndex - 1;
      await upsertUseCase().execute("requests", updatedRequest);
      fetchData();
    } else {
      updatedRequest.stats = "Done";
      updatedRequest.workFlow.tasks = [];
      await upsertUseCase().execute("requests", updatedRequest);

      //  CREATE NOTIFICATION
      const NOTIFICATION_MESSAGE = "Your Service Request has been approved!";
      const NOTIFICATION_RECEIVER = [request.employee.id];
      const NOTIFICATION_REDIRECT = "service";

      createNotification(
        NOTIFICATION_MESSAGE,
        NOTIFICATION_RECEIVER,
        NOTIFICATION_REDIRECT,
      );

      fetchData();
    }
    // return updatedRequest;
  };

  const serviceRequestLogs = async (request, action, message) => {
    request.workFlow.tasks.map(async (item) => {
      const logs = {
        user: { id: item.hierarchy.retrive.id },
        employee: { id: currentUser.employee.id },
        request: { id: request.employee.id },
        activity: `${action} ${request.requestType}`,
        workFlow: request.workFlow.name,
        message: message,
        selectedFiles: request.attachement,
      };
      await upsertUseCase().execute("service_request_logs", logs);
    });
  };

  const fieldData = (label, value) => {
    return (
      <div>
        <label className="mb-2 fs-6">{label}</label>
        <InputFactory
          type={label === "Description" ? "Text" : "String"}
          value={value}
          disabled
        />
      </div>
    );
  };
  console.log("forPROCCESS: ", objects);
  return (
    <>
      {objects.map((request, index) => {
        const employeeName = `${request?.employee?.Firstname || ""} ${
          request?.employee?.Middlename || ""
        } ${request?.employee?.surname || ""}`;
        const hiredDate = formatDate(request?.createdAt);
        const position = request?.employee?.position?.position_title;
        const createdDate = new Date(request?.createdAt);

        const today = new Date();

        // Get difference in milliseconds
        const diffInMs = today - createdDate;

        // Convert milliseconds to days
        const duration = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

        /* approver  */
        const commonApproverRoles =
          request?.workFlow?.tasks[0]?.request !== "approved" &&
          request?.stats !== "Approved" &&
          request?.workFlow?.tasks[0]?.request !== "reject" &&
          request?.stats !== "Rejected";

        const isApproveEnable =
          request?.workFlow?.tasks[0]?.hierarchy?.approve.id ===
            currentUser.employee.id && commonApproverRoles;

        const isForSupervisorApprover = request?.workFlow?.tasks[0]
          ?.isAssignToRequestor
          ? request?.employee?.supervisor?.id === currentUser?.employee?.id &&
            commonApproverRoles
          : isApproveEnable;

        /* rejector  */
        const commonRejector =
          request?.workFlow?.tasks[0]?.request !== "approved" &&
          request.stats !== "Approved" &&
          request?.workFlow?.tasks[0]?.request !== "reject" &&
          request.stats !== "Rejected";
        const isRejectorEnable =
          request?.workFlow?.tasks[0]?.hierarchy?.reject.id ===
            currentUser.employee.id && commonRejector;

        const isForSupervisorRejector = request?.workFlow?.tasks[0]
          ?.isAssignToRequestor
          ? request?.employee?.supervisor?.id === currentUser?.employee?.id &&
            commonRejector
          : isRejectorEnable;

        /* requet handler  */
        const isRequestEnable =
          request?.workFlow?.tasks[0]?.hierarchy?.request.id ===
            currentUser.employee.id &&
          (request.workFlow.tasks[0].request === "approved" ||
            request.workFlow.tasks[0].request === "reject");
        // Define dropdown items dynamically based on request
        const items = [
          {
            key: "1",
            label: (
              <label
                className="w-100 h-100"
                onClick={() => handleViewObj(request)}
              >
                View
              </label>
            ),
          },
          ...(processStatus !== "Done"
            ? [
                ...(isForSupervisorApprover
                  ? [
                      {
                        key: "2",
                        label: (
                          <label
                            className="w-100 h-100"
                            onClick={() =>
                              confirmationDialog(request, "Approve")
                            }
                          >
                            Approve
                          </label>
                        ),
                      },
                    ]
                  : []),
                ...(isForSupervisorRejector
                  ? [
                      {
                        key: "3",
                        label: (
                          <label
                            className="w-100 h-100"
                            onClick={() =>
                              confirmationDialog(request, "Reject")
                            }
                          >
                            Reject
                          </label>
                        ),
                      },
                    ]
                  : []),
                ...(isRequestEnable
                  ? [
                      {
                        key: "4",
                        label: (
                          <label
                            className="w-100 h-100"
                            onClick={() =>
                              confirmationDialog(request, "Validate")
                            }
                          >
                            Next
                          </label>
                        ),
                      },
                    ]
                  : []),
              ]
            : []),
        ];

        return (
          <div
            className="d-flex h-100 p-2 mb-2 bg-white rounded-4 flex-wrap"
            key={index}
          >
            <div className="w-100 mb-3">
              <div
                className="d-flex justify-content-between align-items-center w-100 p-3"
                style={{
                  color: "grey",
                  height: "2.5rem",
                  borderBottom: "1px solid grey",
                }}
              >
                <span style={{ fontSize: "15px", lineHeight: "1rem" }}>
                  {request.requestType}
                </span>
                <Dropdown menu={{ items }} placement="bottomRight" arrow>
                  <i
                    className="bi bi-three-dots"
                    style={{ cursor: "pointer", zoom: 1.5 }}
                  />
                </Dropdown>
              </div>
              <div className="row">
                <div className="col-lg-8 pt-3 ps-5 pb-3">
                  <h6 className="fw-bold">{employeeName}</h6>
                  <div className="d-grid p-0" style={{ color: "grey" }}>
                    <span style={{ fontSize: "13px" }}>{hiredDate}</span>
                    <span style={{ fontSize: "13px" }}>{position}</span>
                    <div>
                      <span
                        className="p-1 border rounded border-warning"
                        style={{ fontSize: "13px" }}
                      >
                        {request.stats}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 d-flex align-items-center justify-content-center">
                  <Progress
                    type="circle"
                    percent={processStatus === "Done" ? 100 : duration}
                    format={() =>
                      processStatus === "Done" ? `Done` : `${duration} day/s`
                    }
                    size={"small"}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {isOnView && (
        <FloatingForm width="30rem">
          <CardView style={{ padding: 0 }}>
            <h4 className="fs-5 fw-bold pt-3 ps-3">Request</h4>
            <hr />
            <div className="d-grid gap-3" style={{ margin: ".5rem 1rem" }}>
              {fieldData("Request Type", object.requestType)}
              <RichText disabled content={object.description} />
              <label className="fw-bold">Upload Documents: </label>
              {object.selectedFiles.length > 0 &&
                object.selectedFiles.map((item, index) => {
                  console.log("ATTECHTM: ", item);
                  const itemName = item.split("_");
                  return (
                    <a key={item} href={item} target="blank">
                      {itemName.slice(1).join("_")}
                    </a>
                  );
                })}
            </div>
            {object.attachement && (
              <div className="d-grid gap-3" style={{ margin: ".5rem 1rem" }}>
                <label className="fw-bold">Verified Documents: </label>
                {object.attachement.length > 0 &&
                  object.attachement.map((item, index) => {
                    console.log("ATTECHTM: ", item);
                    const itemName = item.split("_");
                    return (
                      <a key={item} href={item} target="blank">
                        {itemName.slice(1).join("_")}
                      </a>
                    );
                  })}
                {/* <InputFactory
                  type="File"
                  onChange={(val) => console.log("val: ", val)} // Update reason on change
                  disabled
                  value={object.attachement}
                  className="form-control"
                  required
                /> */}
              </div>
            )}
            <hr />
            <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
              <Button
                type="button"
                className="btn btn-light fs-sm"
                onClick={() => setIsOnView(false)}
              >
                Cancel
              </Button>
            </div>
          </CardView>
        </FloatingForm>
      )}
    </>
  );
}
